export enum BaseButtonColourEnum {
  Purple = 'purple',
  Blue = 'blue',
  Green = 'green',
  Grey = 'grey',
  Red = 'red',
  White = 'white'
}
